/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export const minLabelClassName = 'ms-refine-submenu__input-range-refiner input-range-label-min';
export const maxLabelClassName = 'ms-refine-submenu__input-range-refiner input-range-label-max';
export const minInputClassName = 'ms-refine-submenu__input-range-refiner input-range-input-min';
export const maxInputClassName = 'ms-refine-submenu__input-range-refiner input-range-input-max';
export const minLabelId = 'ms-refine-submenu-range-refiner-label';
export const maxLabelId = 'ms-refine-submenu-max-range-refiner-label';
export const minInputLabelId = 'ms-refine-submenu-min-range-refiner-input';
export const maxInputLabelId = 'ms-refine-submenu-min-range-refiner-input';
